import { memo } from "react";
import type { BotezBokehTemplateProps } from "./types";
import { CORAL_TEXT_LARGE, FONT_BODY, FONT_SCRIPT } from "./utils";
import { normalizeMultilineText } from "@/utils/eventUtils";

export const BotezBokehOurStory = memo(({ event, config, t }: BotezBokehTemplateProps) => {
  const storyContent = event.story || event.description;
  if (!storyContent || !(event.showStory ?? true)) return null;

  const paragraphs = normalizeMultilineText(storyContent)
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <section id="story" className="relative z-10 py-16" style={{ background: config.palette.background }}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8">
          <h2
            className="text-4xl sm:text-5xl mb-4"
            style={{ fontFamily: FONT_SCRIPT, color: CORAL_TEXT_LARGE }}
          >
            {t("events.form.template.ourStory")}
          </h2>
        </div>

        <div className="space-y-6 text-center">
          {paragraphs.map((paragraph, i) => (
            <p
              key={i}
              className="text-base leading-relaxed break-words whitespace-pre-line opacity-80"
              style={{ fontFamily: FONT_BODY, color: config.palette.text }}
            >
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
});

BotezBokehOurStory.displayName = "BotezBokehOurStory";
